import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

import es from '../lang/locals/es.json';
import en from '../lang/locals/en.json';

export const SUPPORTED_LOCALES = ['es', 'en'];
export const DEFAULT_LOCALE = 'es';
export const LOCALE_STORAGE_KEY = 'builder_locale';

export function getStoredLocale() {
    try {
        const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
        if (stored && SUPPORTED_LOCALES.includes(stored)) return stored;
    } catch (e) { /* noop */ }
    return null;
}

const messages = {
    'es': es,
    'en': en,
};

const i18n = new VueI18n({
    locale: getStoredLocale() || DEFAULT_LOCALE,
    fallbackLocale: DEFAULT_LOCALE,
    messages,
});

export default i18n
